import { ThemeUICSSObject } from '@apia/theme';
import { focusOutline, spacing } from '../../../../util';
/* IMPORT HERE */
export const form: ThemeUICSSObject = {
  /* PREPEND HERE */
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  gap: 0,
  mx: 'auto',
  background: 'palette.background.paper',
  border: '1px solid',
  borderColor: 'palette.border.section',
  borderRadius: 'panel',
  boxShadow: '0px 2px 6px #0002',
  width: '100%',
  p: spacing(3),

  '&:focus-within': focusOutline,

  '& > *:focus[class]': {
    outlineWidth: 0,
  },

  '.filter_button_box': {
    position: 'relative',
  },
  '.applied_filters_label': {
    position: 'absolute',
    bottom: '21px',
    left: '20px',
    minWidth: '10px',
    maxHeight: '10px',
    border: '2px solid white',
    borderRadius: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'palette.error.main',
  },

  '.searchTextArea': {
    minHeight: '34px',
    height: '34px',
    resize: 'none',
    py: spacing(2),
    background: 'transparent',
    border: 'none',
  },

  '.ChatBarButton': {
    borderRadius: 'panel',
    height: '34px',
    width: '34px',
    flexShrink: 0,
    background: 'transparent',
    border: 'none',
    color: 'palette.text.primary',
  },
  '.isRecording': {
    borderRadius: 'panel',
    height: '34px',
    width: '34px',
    flexShrink: 0,
    background: 'transparent',
    border: 'none',
    color: 'red',
  },
};
